import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "security-check-container" }
const _hoisted_2 = { class: "container mx-auto px-4 py-8" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "text-3xl font-bold mb-2" }
const _hoisted_5 = { class: "text-gray-600" }
const _hoisted_6 = { class: "bg-white shadow-lg rounded-lg overflow-hidden border border-gray-200" }
const _hoisted_7 = { class: "iframe-container" }
const _hoisted_8 = ["src"]

import { ref } from 'vue';

// 防伪查询外部链接

export default /*@__PURE__*/_defineComponent({
  __name: 'SecurityCheck',
  setup(__props) {

const securityCheckUrl = ref('http://chaxun.hzcg315.com/wscan.aspx?u=4304');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('security_check.title')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('security_check.description')), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("iframe", {
            src: securityCheckUrl.value,
            title: "防伪查询",
            class: "w-full h-[70vh] border-0",
            loading: "lazy"
          }, null, 8, _hoisted_8)
        ])
      ])
    ])
  ]))
}
}

})